module.exports = __webpack_public_path__ + "static/media/register.080e9d07.svg";